module.exports = __webpack_public_path__ + "static/media/read_content_aloud_odiya.f3d4558d.mp3";